/**
 * constants — Shared constants used across UI components.
 *
 * Extracted from index.html.
 */

/**
 * Regex matching common Norwegian company suffixes (AS, ANS, DA, etc.).
 * Used for fuzzy company-name matching — strip suffix before comparing.
 */
export const NORWEGIAN_SUFFIXES = /\b(as|ans|da|sa|nuf|enk|asa|ba|sf|stiftelse|ks|isk|sameie)\s*$/i;

/**
 * Normalize a company name for comparison:
 *   - lowercase, trim
 *   - strip trailing punctuation
 *   - strip Norwegian legal-form suffix
 *
 * @param {string} name
 * @returns {string}
 */
export function normalizeName(name) {
    if (!name) return '';
    return name.trim().toLowerCase().replace(/[.,]+$/, '').replace(NORWEGIAN_SUFFIXES, '').trim();
}

/**
 * Compact variant: normalizeName + strip all whitespace/hyphens/ampersands.
 *
 * @param {string} name
 * @returns {string}
 */
export function compactName(name) {
    return normalizeName(name).replace(/[\s\-&]+/g, '');
}
